import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getSiteId, productAddedMain } from "../../Utils/helper";
import { useDispatch } from "react-redux";
import ComplementryProducts from "./ComplementryProducts";
import { postApiAction } from "../../Utils/helper";
import { decrementCartCount, incrementCartCount } from "../../store/action";

const ProductItem = ({ item }) => {
  const cartValue = item.cart_value && item.cart_value.length > 0 ? item.cart_value[0].quantity : 0;
  const [quantity, setQuantity] = useState(cartValue);

  const dispatch = useDispatch();
  const [showComplementry, setShowComplementry] = useState(false);

  const productAddHandleClick = async (name, id, price, comment) => {
    
    if (item?.complements?.length) {
        setShowComplementry(true);
      /*setTimeout(() => {
        setShowComplementry(false);
      }, 30000);*/
    }else{
      let resp = await productAddedMain(name, id, price, comment, 0, 0, dispatch);
      setQuantity(1)
    }
  };

  const closePopup = () => {
    setShowComplementry(false);
  };

  const incrementQuantity = async () => {
    setQuantity(quantity + 1);
    let postData = {
      product_id: item.id,
      quantity: quantity + 1,
      notes: "",
    };
    let resp = await postApiAction("cart/update", postData,  0, dispatch);
    dispatch(incrementCartCount());
  };

  const decrementQuantity = async () => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
      let postData = {
        product_id: item.id,
        quantity: quantity - 1,
        notes: "",
      };
      let resp = await postApiAction("cart/update", postData,  0, dispatch);
      dispatch(decrementCartCount());
    }
  };

  return (
    <div className="detailcategory_item">
      {showComplementry && (
        <ComplementryProducts
          itemData={item}
          closePopup={closePopup}
        />
      )}
      <Link to={`/${getSiteId()}/products/details/${item.id}`}>
        <div className="larg_image">
          {/* <img src={item.default_image} alt="" /> */}
          <img src={item.default_image} alt="" />
        </div>
      </Link>
      <div className="subText d-flex align-items-center justify-content-between">
        <Link to={`/${getSiteId()}/products/details/${item.id}`}>
          <h4>{item.name}</h4>
        </Link>
        <div className="quantity-box">
        <button
              onClick={() =>
                productAddHandleClick(item.name, item.id, item.price, "")
              }
              className="pluis_icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
              >
                <path
                  d="M38.5 26H26.5V38H22.5V26H10.5V22H22.5V10H26.5V22H38.5V26Z"
                  fill="white"
                />
              </svg>
            </button>
          {/*((quantity > 0) && (
            <div className="number">
              <span className="minus" onClick={decrementQuantity}>
                {(quantity > 1) ? (
                  <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.16699 10.8337H15.8337V9.16699H4.16699V10.8337Z"
                      fill="#1A4988"
                    />
                  </svg>
                  </>
                ) : (
                  <>
                  { <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M13.3337 7.5L13.3337 15.8333L6.66699 15.8333L6.66699 7.5L13.3337 7.5ZM12.0837 2.5L7.91699 2.5L7.08366 3.33333L4.16699 3.33333L4.16699 5L15.8337 5V3.33333L12.917 3.33333L12.0837 2.5ZM15.0003 5.83333L5.00033 5.83333L5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333L15.0003 5.83333Z"
                      fill="#1A4988"
                    />
                  </svg> }
                  </>
                )}
              </span>
              <input type="text" value={quantity} />
              <span className="plus" onClick={incrementQuantity}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15.8337 10.8337L10.8337 10.8337L10.8337 15.8337H9.16699L9.16699 10.8337H4.16699L4.16699 9.16699H9.16699V4.16699L10.8337 4.16699V9.16699L15.8337 9.16699V10.8337Z"
                    fill="#1A4988"
                  />
                </svg>
              </span>
            </div>
          )) || (
            <span>
            <button
              onClick={() =>
                productAddHandleClick(item.name, item.id, item.price, "")
              }
              className="pluis_icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
              >
                <path
                  d="M38.5 26H26.5V38H22.5V26H10.5V22H22.5V10H26.5V22H38.5V26Z"
                  fill="white"
                />
              </svg>
            </button>
            </span>
          )*/}
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
